import { Gates } from "./gates";
import { Signs } from "./signs";

export interface SubstructureData {
  gate: number;
  line: number;
  exactLine: number;
  color: number;
  exactColor: number;
  tone: number;
  exactTone: number;
  base: number;
  exactBase: number;
}

export const Substructure = {
  getFromDecimal: (sign: string, decimalDegrees: number): SubstructureData => {
    const gateOrder = Gates.order;
    let signDegrees = 0;
    for (const iteratingSign of Signs.all) {
      if (iteratingSign === sign) break;
      signDegrees += 30;
    }
    signDegrees += decimalDegrees;

    // Human Design gates start at Gate 41 at 02º00'00" Aquarius, so we have to adjust from 00º00'00" Aries.
    // The distance is 58º00'00" exactly.
    signDegrees += 58;
    if (signDegrees > 360) {
      signDegrees -= 360;
    }

    const percentageThrough = signDegrees / 360;

    const gate = gateOrder[Math.floor(percentageThrough * 64)];
    const exactLine = 384 * percentageThrough;
    const line = (exactLine % 6) + 1;
    const exactColor = 2304 * percentageThrough;
    const color = (exactColor % 6) + 1;
    const exactTone = 13824 * percentageThrough;
    const tone = (exactTone % 6) + 1;
    const exactBase = 69120 * percentageThrough;
    const base = (exactBase % 5) + 1;

    return {
      gate: gate,
      line: Math.floor(line),
      exactLine: Math.floor(exactLine),
      color: Math.floor(color),
      exactColor: Math.floor(exactColor),
      tone: Math.floor(tone),
      exactTone: Math.floor(exactTone),
      base: Math.floor(base),
      exactBase: Math.floor(exactBase),
    };
  },
  get: (sign: string, degrees: number, minutes: number, seconds: number): SubstructureData => {
    const decimalDegrees = degrees + minutes / 60 + seconds / 3600; // thx wikipedia!
    return Substructure.getFromDecimal(sign, decimalDegrees);
  },
};
